import { useState } from "react";

export const useEditorSelectedFontStyles = ({
  selectedComponent,
  layerCompData,
  setSelectedComponent,
  setLayerCompData,
}) => {
  const [selectedFontId, setSelectedFontId] = useState();

  const updateSelctedFontstyle = (id, type) => {
    if (!selectedComponent?.componentStyles) return;

    const latestSelected =
      layerCompData.find((entry) => entry.id === selectedComponent.id) ||
      selectedComponent;

    const tempSlected = {
      ...latestSelected,
      componentStyles: { ...(latestSelected.componentStyles || {}) },
    };
    const selectedStyles = [
      ...(tempSlected.componentStyles.selectedFontStyle || []),
    ];
    const selectedIndex = selectedStyles.indexOf(id);

    if (selectedIndex > -1) {
      selectedStyles.splice(selectedIndex, 1);
    } else if (!(type === "bold" && !tempSlected.componentStyles.boldClick)) {
      selectedStyles.push(id);
    }

    tempSlected.componentStyles.selectedFontStyle = selectedStyles;
    setSelectedComponent(tempSlected);

    const tempLayercompData = layerCompData.map((entry) =>
      entry.id === tempSlected.id
        ? {
            ...entry,
            componentStyles: {
              ...(entry.componentStyles || {}),
              selectedFontStyle: selectedStyles,
            },
          }
        : entry,
    );
    setLayerCompData(tempLayercompData);
  };

  return {
    selectedFontId,
    setSelectedFontId,
    updateSelctedFontstyle,
  };
};
